import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
    AbstractControl,
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    UntypedFormGroup
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { Selection } from 'src/app/domain/models/selection';

@Component({
    selector: 'app-single-selection-control',
    templateUrl: './single-selection-control.component.html',
    styleUrls: ['./single-selection-control.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SingleSelectionControlComponent,
            multi: true
        }
    ],
    standalone: true,
    imports: [
        CommonModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        FlexLayoutModule
    ]
})
export class SingleSelectionControlComponent implements ControlValueAccessor {
    @Input() formGroup: UntypedFormGroup | undefined;
    @Input() selections: Selection[] = [];
    @Input() control: AbstractControl | null | undefined;
    @Input() formControlName: string | undefined;
    @Input() header: string | undefined;
    @Input() label: string | undefined;
    @Input() required = false;
    @Input() requiredMessage: string | undefined;
    @Input() formSubmitted: boolean | undefined;
    @Input() requiredErrorKey: string | undefined;

    public value: any = null;
    readonly headerId = `selection-radio-header-${++SingleSelectionControlComponent.nextId}`;
    readonly labelId = `selection-radio-label-${SingleSelectionControlComponent.nextId}`;
    private static nextId = 0;
    private onChange: (_: any) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: any): void {
        this.value = value;
    }

    registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        void isDisabled;
    }

    updateRadioGroup(event: MatRadioChange) {
        this.value = event.value;
        this.onChange(this.value);
        this.onTouched();
    }

    get showRequiredIndicator(): boolean {
        return this.required;
    }

    get hasRequiredError(): boolean {
        if (this.requiredErrorKey) {
            return this.formGroup?.hasError(this.requiredErrorKey) ?? false;
        }

        return this.control?.hasError('required') ?? false;
    }

    get activeHeadingId(): string {
        return this.header ? this.headerId : this.labelId;
    }
}
